import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import type { IFilePdfViewerProps } from './types';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'https://unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs',
).toString();

export const FilePdfViewer = (props: IFilePdfViewerProps) => {
  const { fileLink } = props;
  const [numPages, setNumPages] = useState<number>();

  const handleLoadSuccess = ({ numPages: nextNumPages }: PDFDocumentProxy) => {
    setNumPages(nextNumPages);
  };

  return (
    <Document file={fileLink} onLoadSuccess={handleLoadSuccess}>
      {Array.from(new Array(numPages), (_el, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          width={900}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      ))}
    </Document>
  );
};
